import type {
  GridProps
} from '@chakra-ui/react'
import {
  Button,
  Grid,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'

export interface OfferSettingsModalProps extends GridProps {
  title?: string
  isOpen: boolean
  isLoading?: boolean
  isReadOnly?: boolean
  onClose: () => void
  onSubmit?: () => Promise<any>
  showFooter?: boolean
}

export const OfferSettingsModal = ({
  children,
  title,
  isOpen,
  isLoading = false,
  isReadOnly = false,
  onClose,
  onSubmit,
  sx,
  showFooter = false,
  ...rest
}: OfferSettingsModalProps) => {
  return (
    <Grid sx={{ ...sx }} {...rest}>
      <Modal size="4xl" isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />

        <ModalContent>
          <ModalHeader>{title}</ModalHeader>

          <ModalBody>{children}</ModalBody>

          {showFooter &&
            <ModalFooter justifyContent='flex-start'>
              {!isReadOnly &&
                <Button
                  ml='auto'
                  isDisabled={isLoading}
                  isLoading={isLoading}
                  colorScheme="green"
                  onClick={onSubmit}>
                  Uložit
                </Button>
              }
            </ModalFooter>
          }
        </ModalContent>
      </Modal>
    </Grid>
  )
}
